import Trigger from 'toggle/Trigger';
import Toggle from 'toggle/Toggle';
import DOMHelper from 'utils/DOMHelpers';
import Observer from 'utils/Observer';

/**
 * Class HeaderToggleGroup that handles base functionality for ToggleGroups like Tabs and Accordions.
 * @class
 */
class HeaderToggleGroup {

    /**
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - ConditionerJS's merged options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;
        this._triggerElements = document.querySelectorAll(this._options.triggerSelector);
        this._panelElements = document.querySelectorAll(this._options.panelSelector);
        this._mouseTriggers = [];
        this._activeToggle = null;

        this._setActiveToggler = this._setActiveToggler.bind(this);
        this._unsetActiveToggler = this._unsetActiveToggler.bind(this);
        this._deactivateActiveTrigger = this._deactivateActiveTrigger.bind(this);

        this.load();
    }


    /**
     * Base options
     */
    static get options() {
        return {
            triggerSelector: null,
            panelSelector: null
        };
    }

    /**
     * Initialize
     * @private
     */
    load() {
        let triggerElements = this._triggerElements;
        let panelElements = this._panelElements;
        let id = this._element.id || '';
        let l = triggerElements.length;
        let panelElement;
        let triggerElement;

        for (let i = 0; i < l; i++) {
            panelElement = panelElements[i];
            triggerElement = triggerElements[i];

            // check if the elements are containing ids
            this._checkId(panelElement, 'panel', i);
            this._checkId(triggerElement, 'trigger', i);

            // create instances for triggers and toggles according to the options
            new Toggle(panelElement, {
                group: `${id}-group`,
                attribute: 'aria-hidden',
                activeState: 'false',
                inActiveState: 'true'
            });

            let trigger = new Trigger(triggerElement, {
                targets: panelElement.id,
                group: `${id}-panel-group`,
                attribute: 'aria-selected',
                method: 'switch',
                toggle: true
            });

            Observer.subscribe(trigger._toggle, trigger._toggle.inActiveEvent, this._unsetActiveToggler.bind(this));
            Observer.subscribe(trigger._toggle, trigger._toggle.activeEvent, this._setActiveToggler.bind(this));
        }

        window.addEventListener('click', this._deactivateActiveTrigger);
    }


    /**
     * Deactivate the active trigger is clicked outside this module's element
     * @param {object} e - event object
     * @private
     */
    _deactivateActiveTrigger(e) {
        if (!DOMHelper.closest(e.target, `#${this._element.id}`) && this._activeToggle) {
            this._activeToggle._element.click();
            this._activeToggle = null;
        }
    }


    /**
     * Set the active toggle
     * @param {object} toggle - The toggle Object
     * @private
     */
    _setActiveToggler(toggle) {
        this._activeToggle = toggle;
    }

    /**
     * Unset the active toggle
     * @param {object} toggle - The toggle Object
     * @private
     */
    _unsetActiveToggler(toggle) {
        if (toggle.id === this._activeToggle._element.id) {
            this._activeToggle = null;
        }
    }


    /**
     * Check if the element contains an id otherwise create and set one.
     * @param {HTMLElement} element - The element to check
     * @param {String} addition - An addition to add
     * @param {int} index - An integer to add
     * @private
     */
    _checkId(element, addition, index) {
        if (!element.id) {
            element.id = `${this._element.id}-${addition}-${index}`;
        }

    }
}

export default HeaderToggleGroup;
